/* ------------------------------------------- */
/*   Queries for CRQ search
/* ------------------------------------------- */

import { AppConfig } from 'AppSrc/core/config/app-config';
import {
  getRESTQuery,
  postRESTQuery,
} from 'AppSrc/core/queries/axios-queries';
import { store } from '../store/store';




const ALL_NETWORKS_VALUE = 'all';


// postCrQ POST request
const postCrq = (crqData, crqId) => {

  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.crq.create}`;

  return postRESTQuery(endpoint, {
    id: crqId, // post endpoint crqId parameter is `id`
    ...crqData,
  })
    .then((response) => {
      console.log('postCrQ RESPONSE: ', response);
      return response.data;
    });
};


// getCrQ GET request
const getCrq = (network, crqId) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.crq.get}`;
  const params = {
    network,
    crq_id: crqId,
  };
  return getRESTQuery(endpoint, params)
    .then((response) => {
      // server data is snake case 🐍
      // eslint-disable-next-line camelcase
      const { crq, work_items } = response.data;
      return ({
        crq,
        // server data is snake case 🐍
        // eslint-disable-next-line camelcase
        workInfoItems: work_items ? work_items : [], // the server should give us work_items but just incase...
      });
    });
};

const getCrqList = (params) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.crq.search}`;
  const newParams = {
    ...params,
    'network-service': '',
    network: params.network || ALL_NETWORKS_VALUE,
  };
  return getRESTQuery(endpoint, newParams)
    .then((response) => {
      const results = response.data.results;
      return results || [];
    });
};

const getCoordinatorCrqDashboard = (params) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.crq.coordinatorDashboard}`;
  const newParams = {
    'network-service': params || '',
  };
  console.log('crqDashboard >>: ', newParams);
  return getRESTQuery(endpoint, newParams).then((response) => {
    console.log('crqDashboard RESPONSE: ', response);
    return response.data;
  });
};


// notificationComms GET request
const getNotificationComms = (params) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.crq.notificationComms}`;
  const param = {
    network: params.network,
    crq_id: params.crqId,
    type: params.type,
    global_unique_identifier: params.guid,
  };

  return getRESTQuery(endpoint, param)
    .then((response) => {
      console.log('CrQ RESPONSE: ', response.data);
      return response.data;
      // return response.data.comms_info;
      // return list3;
      // const results = response.data.comms_info;
    }).catch((error) => {
      console.error(error);
      // redirect to the page not found screen
    });
};

// notificationComms GET request detailed
const getNotificationCommsDetailed = (params) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.crq.notificationComms}`;
  const param = {
    network: params.network,
    crq_id: params.crqId,
    type: params.type,
    global_unique_identifier: params.guid,
  };

  return getRESTQuery(endpoint, param)
    .then((response) => {
      console.log('CrQ RESPONSE: ', response.data);
      return response.data;
      // return response.data.comms_info;
      // return list3;
      // const results = response.data.comms_info;
    }).catch((error) => {
      console.error(error);
      // redirect to the page not found screen
    });
};


const getMyCRQCoordinatorCrqDashboard = (currentNetwork) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.crq.myCrqDashboard}`;
  const user = store.getState().auth.user;
  const newParams = {
    network: currentNetwork,
    coordinator_id: user.remedyIds.fixed,
  };
  return getRESTQuery(endpoint, newParams).then((response) => {
    console.log('res from server', response);
    // return myCrqData.body;
    return response.data;
  });
};

// FL Add approver Post Request
// eslint-disable-next-line camelcase
const flAddApprover = (network, crq_id) => {

  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.approvers.add}`;
  return postRESTQuery(endpoint, {
    network,
    crq_id, // post endpoint crqId parameter is `id`
    action: 'ATTACH_TO_CRQ',
    // group_id: 'SGP000000000024',
  })
    .then((response) => {
      console.log('postCrQ RESPONSE: ', response);
      return response.status;
    });
};

// eslint-disable-next-line camelcase
const individualAddApprover = ({
  network,
  crqId,
  email,
  // eslint-disable-next-line camelcase
  full_name,
  id,
}) => {

  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.approvers.add}`;
  console.log('165 Indi', network, crqId, email, full_name, id);
  const [first, last] = full_name.split(' ');
  return postRESTQuery(endpoint, {
    network,
    crq_id: crqId, // post endpoint crqId parameter is `id`
    id, // id of approver
    userLogin: email,
    userFirstname: first,
    userLastname: last,
    action: 'addApprover',
  })
    .then((response) => {
      console.log('postCrQ RESPONSE: ', response);
      return response.data;
    });
};

export {
  postCrq,
  getCrq,
  getCrqList,
  getCoordinatorCrqDashboard,
  getNotificationComms,
  getNotificationCommsDetailed,
  getMyCRQCoordinatorCrqDashboard,
  flAddApprover,
  individualAddApprover,
};
